var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCommunication = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 12.0001H3.33334C2.96601 12.0001 2.66668 11.7014 2.66668 11.3334V4.83341L7.60001 8.53341C7.71868 8.62275 7.85934 8.66675 8.00001 8.66675C8.14068 8.66675 8.28134 8.62275 8.40001 8.53341L13.3333 4.83341V11.3334C13.3333 11.7014 13.034 12.0001 12.6667 12.0001ZM12.222 4.00008L8.00001 7.16675L3.77801 4.00008H12.222ZM12.6667 2.66675H3.33334C2.23068 2.66675 1.33334 3.56408 1.33334 4.66675V11.3334C1.33334 12.4361 2.23068 13.3334 3.33334 13.3334H12.6667C13.7693 13.3334 14.6667 12.4361 14.6667 11.3334V4.66675C14.6667 3.56408 13.7693 2.66675 12.6667 2.66675Z",
    fill: "#EE5F10"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCommunication, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/communication.b5f7966c.svg";
export { ForwardRef as ReactComponent };